import { render, staticRenderFns } from "./LightCourses.vue?vue&type=template&id=e4861936&scoped=true&"
import script from "./LightCourses.vue?vue&type=script&lang=js&"
export * from "./LightCourses.vue?vue&type=script&lang=js&"
import style0 from "./LightCourses.vue?vue&type=style&index=0&id=e4861936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4861936",
  null
  
)

export default component.exports